module.exports = {
  welcome: {
    product_name: "演神",
    product_slogan: "干得漂亮, 更要讲得漂亮！",
    product_slogan_two: "",
    product_feature_introducation_one: "输入一句话，选择演神优化的方向，生成高质量PPT",
    product_feature_introducation_two: "导入文字稿，获得逻辑细节兼备的PPT",
    product_feature_introducation_three: "插入单页，并选模板，画龙还可点睛",
    start_btn_txt: "立刻体验",
    privacy_policy: "隐私政策",
    terms_of_service: "服务条款",
    welcome_agree_terms_of_service: "登录/注册即表示您同意我们的服务条款和隐私政策",
    copy_right: "演神. 上海移品信息技术有限公司 ©2025  沪ICP备12038410号-15 保留所有权利。",
    register_trial_description:"注册即赠60 AI点数（7天有效），并可享受全部专业版功能。",
  },
  welcome_carousel_slides: {
    slide_1_title: "数据安全",
    slide_1_description: "企业级安全保护，让您的数据始终安全可靠", 
    slide_2_title: "智能文档",
    slide_2_description: "借助AI技术，让您的文档工作更加智能高效",
    slide_3_title: "无缝创作",
    slide_3_description: "Office无缝衔接的创作体验，提升整体工作效率",
  },
  login: {
    title_welcome: "欢迎使用演神",
    title_logout: "登出",
    required_remind_text:'账号或密码不能为空！',
  },
  signup:{
    txt_signup_des: "请注册您的账号",
    txt_btn_signup:"注册",
    txt_btn_go_signup:"去注册",
    txt_btn_go_signin:"去登录",
    input_placeholer_account_email:"邮箱",
    input_placeholer_account_mobile:"手机号",
    input_placeholer_verify_code:"Enter code",
    txt_btn_get_verify_code:"Get Code",
    input_placeholer_account_name:"名称",
    input_placeholder_password:"密码",
    input_placeholder_repeat_password:"确认密码",
    verification_code_send_success:"验证码已发送",
    signup_success_show_user_msg:"恭喜您，已经注册成功，赶快登录体验吧！",
    signup_failed_show_user_msg:"账号出现错误，请联系管理员或重新注册！"
  },
  valiad:{
    show_user_msg_account_required:"请输入账号",
    require_valida:"此项不能为空！",
    email_valida:"邮箱格式不正确",
    mobile_valida:"手机号格式不正确",
    email_mobile_valida:"账号格式不正确",
    password_valida:"密码需要大于8位，且需要包含大写字母、小写字母、数字、特殊字符。",
    password_and_repeat_password_match_valida:"两次密码不一致"
  },
  main: {
    title_menu_gpt: "演神",
    title_menu_template: "Template",
    title_menu_canvas: "Canvas",
    title_menu_account: "Account",
    title_menu_gallary: "Gallary",
    logout_drawer: {
      title: "登出演神",
      cancel_btn_txt: "取消",
      confirm_btn_txt: "确认退出",
      text_logout_remind: "确定要退出登录吗？",
      text_logout_remind_two: "退出后需要重新登录才能访问系统",
      user: {
        name: "用户",
        email: "<EMAIL>",
        avatar: "https://avatars.githubusercontent.com/u/1011681?v=4"
      },
    }
  },
  gpt: {
    text_placeholder_inputbar: "问点什么...",
    text_gpt_optimize: "正在对问题进行检查和优化",
    text_gpt_generating: "正在生成内容",
    text_gpt_generate_success: "生成成功",
    text_gpt_generate_fail: "生成失败",
    text_gpt_noanswer: "GPT没有答案。",
    text_gpt_preprompts_title: "您还可以这样问：",
    text_gpt_answer_thumbup: "有用",
    text_gpt_answer_thumbdown: "没用",
    text_gpt_answer_scored: "已评价",
  },
  ppt_addin: {
    process: {
      text_ppt_generating_content: "正在生成内容...",
      text_ppt_generating_content_failed: "生成内容失败",
      text_ppt_generating_content_parsing: "正在解析内容...",
      text_ppt_generating_text: "正在生成第{0}页幻灯片内容",
      text_ppt_make_slide:'正在制作第 {0}/{1} 页幻灯片',
      text_ppt_generating_total: "共生成 {0} 页幻灯片",
      text_ppt_generating_image_prompt: "正在生成图片描述...",
      text_ppt_generating_image: "正在生成图片...",
      text_ppt_generating_image_download: "正在下载和插入图片...",
      text_ppt_generating_image_success: "操作已完成，已在第{0}页插入一张图片。",
      text_ppt_generating_expand_content: "正在丰富本页内容...",
      text_ppt_generating_expand_content_success: "操作已完成，在第{0}页增加{1}个字。",
      text_ppt_generating_extract_content: "正在提炼本页内容...",
      text_ppt_generating_extract_content_success: "操作已完成，在第{0}页删减{1}个字。",
      text_ppt_generation_update_slide: "正在更新幻灯片",
      text_ppt_generating_icon: "正在生成图标...",
      text_ppt_generating_icon_success: "操作已完成，智能生成 {0} 个图标，已重新布局",
      text_ppt_generating_ppt_onepage: "正在生成幻灯片...",
      text_ppt_generating_ppt_onepage_success: "操作成功，已生成幻灯片。",
      text_blink_translate:'翻译中',
      text_blink_think:'思考中',
      text_blink_intent_recognition:'意图识别中', 
      text_blink_intent_recognition_success:'意图识别成功', 
      text_blink_update_slides_content:'正在学习最新内容', 
      text_blink_prompt_recognition:'识别和理解新指令', 
      text_blink_response_streaming:'正在接收AI响应', 
      text_blink_generate_content:'正在生成内容',
      text_blink_image_generate_key_elements:'智能提取关键元素和设计场景',
      text_blink_image_generate_prompt:'智能构建图像提示词',
      text_blink_image_generate:'正在创作图像',
      text_blink_enchance_prompt:'提示词智能优化中',
      text_blink_slides_build:'开始制作PPT',
      // text_msg_complete_translate:'翻译完成，请点击查看详情！<br/> 更多功能敬请期待!',
      // text_msg_complete_onepageslide_generate:'单页PPT 制作完成，可点击查看详情！<br/> 更多功能敬请期待!',
      // text_msg_complete_allSlides_generate:'PPT制作完成，可点击查看详情！<br/> 更多功能敬请期待!',
      text_msg_complete_translate:'翻译完成，请点击查看详情！\\n 更多功能敬请期待!',
      text_msg_complete_onepageslide_generate:'单页PPT 制作完成，可点击查看详情！\\n 更多功能敬请期待!',
      text_msg_complete_allSlides_generate:'PPT制作完成，可点击查看详情！\\n 更多功能敬请期待!',
    },
    dialog: {
      translate_all_title:'全文翻译详情',
      onepageslide_title: '内容详情'
    },
    message: {
      text_message_nocontent_process: "没有内容可处理。",
      text_message_not_select_slide: "你没有选择幻灯片。",
      text_message_input_placeholder: "请描述你的想法或要求...",
      text_message_press_key: "按 '/' 或 '、' 打开AI命令菜单",
      text_userlog_format_task: "当前任务：",
      text_userlog_format_current_page: "第{0}页：",
      text_userlog_format_reference_content: "参考的内容：",
      text_userlog_format_optimized_content: "优化的内容：",
      text_userlog_format_your_description: "你的描述："
    }
  },
  gallary: {
    ui: {
      input_form_keywords_label: "关键词",
      input_form_keywords_placeholder: "图标名称，例如：发送按钮",
      input_form_category_label: "分类",
      input_form_category_placeholder: "选择分类",
      input_form_style_label: "风格",
      input_form_style_placeholder: "选择风格",
      input_form_style_nodata_text: "先选择分类",
      input_form_bg_color_label: "背景",
      input_form_bg_color_Placeholder: "选择背景色",
      input_form_button_generate: "生成"
    }
  },
  ppt_add_in_main: {
    login:"登录",
    login_home_title: "欢迎使用演神",
    login_home_account_hint: "账号",
    login_home_account_empty: "请输入账号",
    login_home_password_hint: "密码",
    login_home_password_empty: "请输入密码",
    paramter_error:"Office文件属性异常，请关闭Office或退出演神重新登录！",
    text_content_empty: "请输入内容",
    server_general_error_message: "AI服务器繁忙，请您稍后再试~",
    text_copy_success: "复制成功！",
    text_like: "感谢支持，我们会持续优化！",
    logout_time_remind: "再按一次登出演神账号",
    input_word_count_limit: "不好意思，目前最多支持2000的输入长度，请您精简问题描述",
    user_settings: "图片设置",
    subscription_settings: "订阅中心",
    save: "保存",
    confirm: "确认",
    subtitle_mode:' 模式：',
    business_style: "商务",
    business_style_desc: "专业/简洁",
    free_style: "自由",
    free_style_desc: "创意/抽象",
    subtitle_style:' 风格：',
    style_mode_ai: "AI搭配风格",
    style_mode_human: "手动选风格",
    art_style_overview: "查看/选择风格",
    // img_style_select_title:"图片模式和风格",
    img_style_select_title:"选模式/风格",
    img_style_selected_title:'已选风格：',
    img_style_selected_AI:'AI智能搭配风格',
    img_mode_select_remind_txt:'《演神》按照【模式+风格】进行配图',
    txt_remind_pls_select_image_style: '请选择图片风格',
    template_select_title:"选模板",
    template_select_font_type:"选字体",
    template_select_shape_color:"选主色",
    input_bar_placeholder_after_upload_file_first:"当前可通过文件：[ ",
    input_bar_placeholder_after_upload_file_second:" ]生成；您可输入文字描述生成PPT的要求或直接点击发送",
    input_bar_placeholder_uploading_first:"正在上传文件：[ ",
    input_bar_placeholder_uploading_second:" ]",
    input_bar_placeholder_upload_file_first:"通过文件[ ",
    input_bar_placeholder_upload_file_second:" ]生成PPT演示文稿",
    btn_select_file:'参考文件',
    btn_select_template_default:'选模板',
    btn_select_template:'已选模板',
    btn_clear_select_template:'清空',
    msg_pls_select_template:'请选择一个模板',
    msg_pls_select_file:'请选择一个文件',
    msg_pls_select_sys_template:'暂无企业模板，请选择系统模板',
    template_select_tab_name_semantic:'语义',
    template_select_tab_name_sys:'视觉',
    template_select_tab_name_ent:'企业',
    template_select_tab_name_whole:'企业',
    uniform_operation_loading_default:'加载中...',
    msg_something_error:'遇到点小问题，请重试！',
    loading_txt_uniform_operation_begin:'开始处理中...',
    loading_txt_uniform_operation:'已完成: ',
    // input_bar_placeholder_after_upload_file_first:"Generate PPT from file：[ ",
    // input_bar_placeholder_after_upload_file_second:" ], Continue typing or send",
    // input_bar_placeholder_uploading_first:"Uploading file：[ ",
    // input_bar_placeholder_uploading_second:" ]",
    // input_bar_placeholder_upload_file_first:"File[ ",
    // input_bar_placeholder_upload_file_second:" ]to PPT",
    txt_title_enchance_prompt_list:"选择提示词以获得满意的结果：",
    txt_remiind_enchance_prompt_confirm:"选择提示开始生成：",
    txt_remind_pls_select_template_whole_task_type: '请在企业模板任务中使用企业模板',
    txt_remind_pls_select_template_onepage_task_type: '请在在单页任务使用单页模板',
  },
  home: {
    text_general_placeholder:"用演神生成内容",
    text_general_warring_text:"*AI 生成的内容可能不正确",
    text_general_warring_ppt_init_error:"PPT程序初始化错误，请右键刷新",
    server_error_message: "服务优化中，请您稍后再试~",
    server_error_but_success_message: "服务优化中，请稍后再试~",
    generating_sending_remind_message: "正在生成中，请稍后~",
    generating_sending_remind_message_whole_template: "为了确保最终效果，请先不要操作。",
    generating_sending_remind_message_whole_template_process: '共{0}页，演神正在操作第{1}页',
    llm_service_error: "大模型相关服务暂时不可用",
    content_empty:"请提供文本内容",
    text_content_empty_unsupport_shape_type: "暂不支持此类型图形，请期待！",
    login_status_error: "登录状态过期，需重新登录！",
    action_header_menu:"快速开始",
    license_error_description_901: "无可用订阅",
    license_error_description_902: "未分配订阅，请联系管理员",
    license_error_description_903: "订阅不可用，请联系管理员",
    license_error_description_904: "余额不足，请联系管理员",
  },
  chat: {
    chat_document_init_loading: "演神 正在学习文档最新内容...",
    chat_log_init_loading: "加载历史消息...",
    chat_log_update_faile: "最新内容更新失败，《演神》根据内容回答",
    message_action_insert: "插入",
    message_action_go_to_optimize: "调优",
    message_action_outline_optimize: "大纲调优",
    message_action_change_template_regenerate: "换模板生成",
    message_action_go_to_details: "详情",
    message_action_outline_ppt: "生成PPT",
    default_input_placeholder: "您可以提问或描述需求生成PPT，或按 '/' 打开快捷菜单",
    onepage_slide_input_placeholder: "您可以选择模板，然后上传参考文件，或直接输入内容和要求，快速生成PPT",
    // default_input_placeholder: "Input prompt or type '/' for menus",
    create_slide_input_placeholder: "请描述您的要求或想要创建的PPT主题或场景",
    optimize_slide_input_placeholder: "请描述您的要求，比如：帮我丰富内容",
    input_bar_ai_action_more: "操作：",
    input_bar_ai_action_title: "建议：",
    input_bar_user_select_action_title: "您选择了：",
    input_bar_suggest_action_abstract: "生成摘要",
    input_bar_suggest_action_summary: "总结一下",
    text_slide_outline_title:"演示文稿大纲调优",
    text_prompt_generate_base_title_pageindex: '当前PPT页码是：Page ',
    text_prompt_generate_base_title_new_slide_title: '新页标题和内容是：',
    text_prompt_change_template_regenerate: '切换模板重新生成',
  },
  optimize_home: {
    home_title: "调优工作台",
    btn_text_replace: "替换",
    btn_text_insert: "插入",
    btn_text_regenerate: "重写",
    btn_text_adjust: "调整",
    text_finish_remind_text_optimize: "*内容已生成，请继续您的操作",
    text_warning_select_no_shape:"请选择文稿中的一个目标区",
    text_warning_ai:"*AI生成内容可能不正确",
    btn_text_outline_to_slide: "生成PPT",
    btn_text_outline_optimize: "优化大纲",
    text_input_outline_title: "您想如何调整大纲",
    text_input_placeholder_outline: "请输入您的要求, 或直接点击下方生成PPT",
  },
  dialog: {
    input_content_not_null: "请描述您的要求",
    error_message: "遇到错误，请稍后重试~"
  },
  welcomeMessageCard: {
    tittle: "您可以快速开始一些操作...",
    action_create_whole_template_slides: "企业模板生成完整PPT...     ",
    action_create_whole_slides: "快速创建完整PPT...     ",
    action_create_one_page_slide: "快速创建单页PPT...     ",
    action_create_slide_outline: "快速创建PPT大纲...     ",
    action_create_ppt_from_file: "选文件创建完整PPT...     ",
    actoin_optimize_current_page_slide: "调整 当前页PPT...     "
    // tittle: "Get started:",
    // action_create_whole_slides: "Create Full Deck...     ",
    // action_create_one_page_slide: "Generate Slide...     ",
    // action_create_slide_outline: "Outline...     ",
    // action_create_ppt_from_file: "Start from File...     ",
    // actoin_optimize_current_page_slide: "Adjust Current Slide...     "
  },
  ppt_select_state: {
    select_no_slide: "没有选中任何slide",
    select_one_slide: "选中单个slide",
    select_mluti_slide: "选中多个slide",
    select_no_shape: "没有选中任何shape",
    select_one_shape: "选中单个shape",
    select_one_shape_img: "选中单个图片shape",
    select_one_shape_txt: "选中单个文本shape",
    select_mluti_shapes: "选中多个shape",
    select_mluti_img_shapes: "选中多个图片shape",
    select_mluti_txt_shapes: "选中多个文本shape",
  },
  ppt_menus: {
    ppt_menus_full_template_ppt:"模板PPT",
    ppt_menus_full_ppt:"完整PPT",
    ppt_menus_template_whole_ppt:"完整PPT-通用模板",
    ppt_menus_template:"单页PPT",
    ppt_menus_bp_classic:"BP-经典",
    ppt_menus_bp_innovative:"BP-新颖",
    ppt_menus_one_page:"单页PPT",
    ppt_menus_one_page_consulat:"咨询画布",
    ppt_menus_business_canvas:"商业模式画布",
    ppt_menus_market_analysis:"市场规模分析",
    ppt_menus_crossing_chasm:"跨越鸿沟理论",
    ppt_menus_ppt_outline:"PPT大纲",
    ppt_menus_ppt_translate_all:"翻译全文",
    ppt_menus_ppt_translate_all_en:"翻译全文-英文",
    ppt_menus_ppt_translate_all_zh:"翻译全文-中文",
    ppt_menus_ppt_uniform_style:"样式风格",
    ppt_menus_ppt_uniform_style_font:"统一字体",
    ppt_menus_ppt_uniform_style_color:"统一主色调",
    ppt_menus_refine_outline:"优化大纲",
    ppt_menus_outline_to_ppt:"大纲生成PPT",
    ppt_menus_file_to_ppt:"从文件创建",
  },
  ppt_menus_length: {
    menu_title:"长度",
    menus_length_short:"精炼的",
    menus_length_normal:"正常的",
    menus_length_rich:"丰富的",
  },
  ppt_menus_tone: {
    menu_title:"风格",
    menus_tone_expert:"专业的",
    menus_tone_normal:"正常的",
    menus_tone_casual:"随意的",
  },
  // ppt_menus: {
  //   ppt_menus_full_ppt:"Full Deck",
  //   ppt_menus_template:"Template",
  //   ppt_menus_bp_classic:"BP-Classic",
  //   ppt_menus_bp_innovative:"BP-Innovative",
  //   ppt_menus_one_page:"One-page PPT",
  //   ppt_menus_business_canvas:"Business Canvas",
  //   ppt_menus_market_analysis:"Market Analysis",
  //   ppt_menus_crossing_chasm:"Cross the Chasm",
  //   ppt_menus_ppt_outline:"PPT Outline",
  //   ppt_menus_refine_outline:"Refine Outline",
  //   ppt_menus_outline_to_ppt:"Outline to PPT",
  //   ppt_menus_file_to_ppt:"File to PPT",
  // },
  // ppt_menus_length: {
  //   menu_title:"Length",
  //   menus_length_short:"Concise",
  //   menus_length_normal:"Normal",
  //   menus_length_rich:"Rich",
  // },
  // ppt_menus_tone: {
  //   menu_title:"Tone",
  //   menus_tone_expert:"Expert",
  //   menus_tone_normal:"Normal",
  //   menus_tone_casual:"Casual",
  // },
  ppt_action_type: {
    suggest_action_title:"智能标题",
    suggest_action_consolidate:"整理合并",
    suggest_action_optimize:"重新表达",
    suggest_action_smart_img:"智能配图",
    suggest_action_another_img:"再配张图",
    suggest_action_trans_zh_to_en:"汉译英",
    suggest_action_smart_replace_img:"智能换图",
    suggest_action_generate_ppt_outline: "根据大纲生成PPT",
    suggest_action_enrich_one_page_content:"丰富本页",
    suggest_action_generate_enrich_one_page_content:"由标题生成",
    // suggest_action_title:"Suggest Title",
    // suggest_action_consolidate:"Merge Text",
    // suggest_action_optimize:"Optimize",
    // suggest_action_smart_img:"Add Image",
    // suggest_action_another_img:"More Image",
    // suggest_action_trans_zh_to_en:"Zh to En",
    // suggest_action_smart_replace_img:"Smart Img Replace",
    // suggest_action_generate_ppt_outline: "Generate a PPT based on the outline",
  },
  //Impressionism, Post-Impressionism, Symbolism, Pop art, minimalism, Conceptual art, Contemporary art, Baroque, Rococo, Neoclassicism, 
  //Romanticism, realism, Expressionism, Cubism, Surrealism, Abstract Expressionism
  //印象派、后印象派、象征主义、波普艺术、极简主义、观念艺术、当代艺术、巴洛克、洛可可、新古典主义、
  // 浪漫主义、现实主义、表现主义、立体主义、超现实主义、抽象表现主义
  ppt_img_style: {
    img_msg_btn:'风格: ',
    img_style_surreal:"超现实",
    img_style_cyberpunk:"赛博朋克",
    img_style_oil:"油画",
    img_style_ink:"水墨画",
    img_style_illustration:"插图",
    img_style_stickers:"贴纸",
    img_style_impressionism:"印象派",
    img_style_post_impressionism:"后印象派",
    img_style_symbolism:"象征主义",
    img_style_pop_art:"波普艺术",
    img_style_minimalism:"极简主义",
    img_style_conceptual_art:"概念艺术",
    img_style_contemporary_art:"当代艺术",
    img_style_baroque:"巴洛克",
    img_style_rococo:"洛可可",
    img_style_neoclassicism:"新古典主义",
    img_style_romanticism:"浪漫主义",
    img_style_realism:"现实主义",
    img_style_expressionism:"表现主义",
    img_style_cubism:"立体主义",
    img_style_surrealism:"超现实主义",
    img_style_abstract_expressionism:"抽象表现主义",
    img_style_photorealism:"照片写实",
    img_style_contemporary_documentary_photography:"当代摄影",
    // img_style_surreal:"Surreal",
    // img_style_cyberpunk:"Cyberpunk",
    // img_style_oil:"Oil painting",
    // img_style_ink:"Ink painting",
    // img_style_illustration:"Illustration",
    // img_style_stickers:"Stickers",
  },
  ppt_img_mode: {
    img_mode_business:'商务',
    img_mode_free:"自由",
  },
  subscription: {
    loading_txt: "加载中...",
    go_to_office_web_txt: "官网",
    home_title_txt: "账号中心",
    home_tab_my_subscription_txt: "我的订阅",
    home_tab_buy_subscription_txt: "购买订阅",
    home_credits_info_total: "总点数",
    home_credits_info_used: "已用点数",
    home_credits_info_balance: "剩余点数",

    history_list_title: "订阅历史记录",
    history_list_item_status_active: "活跃",
    history_list_item_status_expire: "过期",
    history_list_item_status_pending: "待激活",

    loading_product_page_home_txt:"加载产品信息...",
    btn_product_page_card_buy:"立即购买",

    checkout_page_payment_method_title: "选择支付方式",
    checkout_page_payment_method_qr_code: "扫码支付",
    checkout_page_payment_method_coming_soon: "即将支持",
    checkout_page_payment_Wechat: "微信支付",
    checkout_page_payment_Alipay: "支付宝",
    checkout_page_payment_Stripe: "卡支付-Stripe",
    checkout_page_payment_Bank: "银联",

    checkout_page_payment_amount: "支付金额",

    checkout_page_payment_check_subscription_info: "确认订阅信息",

    checkout_page_payment_remind_txt: "请确认订阅信息无误后支付！",
    checkout_page_payment_btn_pay: "去支付",

    checkout_page_payment_order_loading_txt: "确认订单中...",

    pay_page_title_qr_code: "扫码支付",
    pay_page_title_timer: "支付倒计时",
    pay_page_title_pay_remind_txt_wechat: "请使用微信扫码支付",
    pay_page_title_pay_remind_txt_alipay: "请使用支付宝扫码支付",
    pay_page_title_pay_time_out: "支付超时",
    pay_page_title_pay_time_out_notice: "很抱歉，支付已超时。请重新发起购买。",

    pay_succeed_page_title: "支付成功！",
    pay_succeed_page_thanks: "感谢购买，订阅已激活",
    pay_succeed_page_stripe_thanks: "感谢购买，订阅已激活, 请返回PowerPoint继续使用",
    pay_succeed_page_btn_close_current_page: "关闭页面",
    pay_succeed_page_btn_go_to_subscription: "查看我的订阅",

    download_app_btn_txt: "去安装",
    logout: "退出",
    logout_confirm: "确认退出？"
  }
};